/** @format */

// Common images
import assessment from "./_assessment"
import common from "./_common"
import dashboard from "./_dashboard"
import pm from "./_pm"
import tms from "./_tms"
import users from "./_users"
import company from "./_company"
import keyplayer from "./_keyplayer"

const images = {
    assessment: assessment,
    common: common,
    dashboard: dashboard,
    pm: pm,
    tms: tms,
    users: users,
    company: company,
    keyplayer: keyplayer,
}

export default images
